(function () {
	'use strict';

	(function(t,e,i){function n(i,n,o){var r=e.createElement(i);return n&&(r.id=Z+n),o&&(r.style.cssText=o),t(r)}function o(){return i.innerHeight?i.innerHeight:t(i).height()}function r(e,i){i!==Object(i)&&(i={}),this.cache={},this.el=e,this.value=function(e){var n;return void 0===this.cache[e]&&(n=t(this.el).attr("data-cbox-"+e),void 0!==n?this.cache[e]=n:void 0!==i[e]?this.cache[e]=i[e]:void 0!==X[e]&&(this.cache[e]=X[e])),this.cache[e]},this.get=function(e){var i=this.value(e);return t.isFunction(i)?i.call(this.el,this):i};}function h(t){var e=W.length,i=(z+t)%e;return 0>i?e+i:i}function a(t,e){return Math.round((/%/.test(t)?("x"===e?E.width():o())/100:1)*parseInt(t,10))}function s(t,e){return t.get("photo")||t.get("photoRegex").test(e)}function l(t,e){return t.get("retinaUrl")&&i.devicePixelRatio>1?e.replace(t.get("photoRegex"),t.get("retinaSuffix")):e}function d(t){"contains"in y[0]&&!y[0].contains(t.target)&&t.target!==v[0]&&(t.stopPropagation(),y.focus());}function c(t){c.str!==t&&(y.add(v).removeClass(c.str).addClass(t),c.str=t);}function g(e){z=0,e&&e!==!1&&"nofollow"!==e?(W=t("."+te).filter(function(){var i=t.data(this,Y),n=new r(this,i);return n.get("rel")===e}),z=W.index(_.el),-1===z&&(W=W.add(_.el),z=W.length-1)):W=t(_.el);}function u(i){t(e).trigger(i),ae.triggerHandler(i);}function f(i){var o;if(!G){if(o=t(i).data(Y),_=new r(i,o),g(_.get("rel")),!$){$=q=!0,c(_.get("className")),y.css({visibility:"hidden",display:"block",opacity:""}),L=n(se,"LoadedContent","width:0; height:0; overflow:hidden; visibility:hidden"),b.css({width:"",height:""}).append(L),D=T.height()+k.height()+b.outerHeight(!0)-b.height(),j=C.width()+H.width()+b.outerWidth(!0)-b.width(),A=L.outerHeight(!0),N=L.outerWidth(!0);var h=a(_.get("initialWidth"),"x"),s=a(_.get("initialHeight"),"y"),l=_.get("maxWidth"),f=_.get("maxHeight");_.w=(l!==!1?Math.min(h,a(l,"x")):h)-N-j,_.h=(f!==!1?Math.min(s,a(f,"y")):s)-A-D,L.css({width:"",height:_.h}),J.position(),u(ee),_.get("onOpen"),O.add(F).hide(),y.focus(),_.get("trapFocus")&&e.addEventListener&&(e.addEventListener("focus",d,!0),ae.one(re,function(){e.removeEventListener("focus",d,!0);})),_.get("returnFocus")&&ae.one(re,function(){t(_.el).focus();});}var p=parseFloat(_.get("opacity"));v.css({opacity:p===p?p:"",cursor:_.get("overlayClose")?"pointer":"",visibility:"visible"}).show(),_.get("closeButton")?B.html(_.get("close")).appendTo(b):B.appendTo("<div/>"),w();}}function p(){y||(V=!1,E=t(i),y=n(se).attr({id:Y,"class":t.support.opacity===!1?Z+"IE":"",role:"dialog",tabindex:"-1"}).hide(),v=n(se,"Overlay").hide(),S=t([n(se,"LoadingOverlay")[0],n(se,"LoadingGraphic")[0]]),x=n(se,"Wrapper"),b=n(se,"Content").append(F=n(se,"Title"),I=n(se,"Current"),P=t('<button type="button"/>').attr({id:Z+"Previous"}),K=t('<button type="button"/>').attr({id:Z+"Next"}),R=n("button","Slideshow"),S),B=t('<button type="button"/>').attr({id:Z+"Close"}),x.append(n(se).append(n(se,"TopLeft"),T=n(se,"TopCenter"),n(se,"TopRight")),n(se,!1,"clear:left").append(C=n(se,"MiddleLeft"),b,H=n(se,"MiddleRight")),n(se,!1,"clear:left").append(n(se,"BottomLeft"),k=n(se,"BottomCenter"),n(se,"BottomRight"))).find("div div").css({"float":"left"}),M=n(se,!1,"position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;"),O=K.add(P).add(I).add(R)),e.body&&!y.parent().length&&t(e.body).append(v,y.append(x,M));}function m(){function i(t){t.which>1||t.shiftKey||t.altKey||t.metaKey||t.ctrlKey||(t.preventDefault(),f(this));}return y?(V||(V=!0,K.click(function(){J.next();}),P.click(function(){J.prev();}),B.click(function(){J.close();}),v.click(function(){_.get("overlayClose")&&J.close();}),t(e).bind("keydown."+Z,function(t){var e=t.keyCode;$&&_.get("escKey")&&27===e&&(t.preventDefault(),J.close()),$&&_.get("arrowKey")&&W[1]&&!t.altKey&&(37===e?(t.preventDefault(),P.click()):39===e&&(t.preventDefault(),K.click()));}),t.isFunction(t.fn.on)?t(e).on("click."+Z,"."+te,i):t("."+te).live("click."+Z,i)),!0):!1}function w(){var e,o,r,h=J.prep,d=++le;if(q=!0,U=!1,u(he),u(ie),_.get("onLoad"),_.h=_.get("height")?a(_.get("height"),"y")-A-D:_.get("innerHeight")&&a(_.get("innerHeight"),"y"),_.w=_.get("width")?a(_.get("width"),"x")-N-j:_.get("innerWidth")&&a(_.get("innerWidth"),"x"),_.mw=_.w,_.mh=_.h,_.get("maxWidth")&&(_.mw=a(_.get("maxWidth"),"x")-N-j,_.mw=_.w&&_.w<_.mw?_.w:_.mw),_.get("maxHeight")&&(_.mh=a(_.get("maxHeight"),"y")-A-D,_.mh=_.h&&_.h<_.mh?_.h:_.mh),e=_.get("href"),Q=setTimeout(function(){S.show();},100),_.get("inline")){var c=t(e);r=t("<div>").hide().insertBefore(c),ae.one(he,function(){r.replaceWith(c);}),h(c);}else _.get("iframe")?h(" "):_.get("html")?h(_.get("html")):s(_,e)?(e=l(_,e),U=new Image,t(U).addClass(Z+"Photo").bind("error",function(){h(n(se,"Error").html(_.get("imgError")));}).one("load",function(){d===le&&setTimeout(function(){var e;t.each(["alt","longdesc","aria-describedby"],function(e,i){var n=t(_.el).attr(i)||t(_.el).attr("data-"+i);n&&U.setAttribute(i,n);}),_.get("retinaImage")&&i.devicePixelRatio>1&&(U.height=U.height/i.devicePixelRatio,U.width=U.width/i.devicePixelRatio),_.get("scalePhotos")&&(o=function(){U.height-=U.height*e,U.width-=U.width*e;},_.mw&&U.width>_.mw&&(e=(U.width-_.mw)/U.width,o()),_.mh&&U.height>_.mh&&(e=(U.height-_.mh)/U.height,o())),_.h&&(U.style.marginTop=Math.max(_.mh-U.height,0)/2+"px"),W[1]&&(_.get("loop")||W[z+1])&&(U.style.cursor="pointer",U.onclick=function(){J.next();}),U.style.width=U.width+"px",U.style.height=U.height+"px",h(U);},1);}),U.src=e):e&&M.load(e,_.get("data"),function(e,i){d===le&&h("error"===i?n(se,"Error").html(_.get("xhrError")):t(this).contents());});}var v,y,x,b,T,C,H,k,W,E,L,M,S,F,I,R,K,P,B,O,_,D,j,A,N,z,U,$,q,G,Q,J,V,X={html:!1,photo:!1,iframe:!1,inline:!1,transition:"elastic",speed:300,fadeOut:300,width:!1,initialWidth:"600",innerWidth:!1,maxWidth:!1,height:!1,initialHeight:"450",innerHeight:!1,maxHeight:!1,scalePhotos:!0,scrolling:!0,opacity:.9,preloading:!0,className:!1,overlayClose:!0,escKey:!0,arrowKey:!0,top:!1,bottom:!1,left:!1,right:!1,fixed:!1,data:void 0,closeButton:!0,fastIframe:!0,open:!1,reposition:!0,loop:!0,slideshow:!1,slideshowAuto:!0,slideshowSpeed:2500,slideshowStart:"start slideshow",slideshowStop:"stop slideshow",photoRegex:/\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,retinaImage:!1,retinaUrl:!1,retinaSuffix:"@2x.$1",current:"image {current} of {total}",previous:"previous",next:"next",close:"close",xhrError:"This content failed to load.",imgError:"This image failed to load.",returnFocus:!0,trapFocus:!0,onOpen:!1,onLoad:!1,onComplete:!1,onCleanup:!1,onClosed:!1,rel:function(){return this.rel},href:function(){return t(this).attr("href")},title:function(){return this.title}},Y="colorbox",Z="cbox",te=Z+"Element",ee=Z+"_open",ie=Z+"_load",ne=Z+"_complete",oe=Z+"_cleanup",re=Z+"_closed",he=Z+"_purge",ae=t("<a/>"),se="div",le=0,de={},ce=function(){function t(){clearTimeout(h);}function e(){(_.get("loop")||W[z+1])&&(t(),h=setTimeout(J.next,_.get("slideshowSpeed")));}function i(){R.html(_.get("slideshowStop")).unbind(s).one(s,n),ae.bind(ne,e).bind(ie,t),y.removeClass(a+"off").addClass(a+"on");}function n(){t(),ae.unbind(ne,e).unbind(ie,t),R.html(_.get("slideshowStart")).unbind(s).one(s,function(){J.next(),i();}),y.removeClass(a+"on").addClass(a+"off");}function o(){r=!1,R.hide(),t(),ae.unbind(ne,e).unbind(ie,t),y.removeClass(a+"off "+a+"on");}var r,h,a=Z+"Slideshow_",s="click."+Z;return function(){r?_.get("slideshow")||(ae.unbind(oe,o),o()):_.get("slideshow")&&W[1]&&(r=!0,ae.one(oe,o),_.get("slideshowAuto")?i():n(),R.show());}}();t[Y]||(t(p),J=t.fn[Y]=t[Y]=function(e,i){var n,o=this;if(e=e||{},t.isFunction(o))o=t("<a/>"),e.open=!0;else if(!o[0])return o;return o[0]?(p(),m()&&(i&&(e.onComplete=i),o.each(function(){var i=t.data(this,Y)||{};t.data(this,Y,t.extend(i,e));}).addClass(te),n=new r(o[0],e),n.get("open")&&f(o[0])),o):o},J.position=function(e,i){function n(){T[0].style.width=k[0].style.width=b[0].style.width=parseInt(y[0].style.width,10)-j+"px",b[0].style.height=C[0].style.height=H[0].style.height=parseInt(y[0].style.height,10)-D+"px";}var r,h,s,l=0,d=0,c=y.offset();if(E.unbind("resize."+Z),y.css({top:-9e4,left:-9e4}),h=E.scrollTop(),s=E.scrollLeft(),_.get("fixed")?(c.top-=h,c.left-=s,y.css({position:"fixed"})):(l=h,d=s,y.css({position:"absolute"})),d+=_.get("right")!==!1?Math.max(E.width()-_.w-N-j-a(_.get("right"),"x"),0):_.get("left")!==!1?a(_.get("left"),"x"):Math.round(Math.max(E.width()-_.w-N-j,0)/2),l+=_.get("bottom")!==!1?Math.max(o()-_.h-A-D-a(_.get("bottom"),"y"),0):_.get("top")!==!1?a(_.get("top"),"y"):Math.round(Math.max(o()-_.h-A-D,0)/2),y.css({top:c.top,left:c.left,visibility:"visible"}),x[0].style.width=x[0].style.height="9999px",r={width:_.w+N+j,height:_.h+A+D,top:l,left:d},e){var g=0;t.each(r,function(t){return r[t]!==de[t]?(g=e,void 0):void 0}),e=g;}de=r,e||y.css(r),y.dequeue().animate(r,{duration:e||0,complete:function(){n(),q=!1,x[0].style.width=_.w+N+j+"px",x[0].style.height=_.h+A+D+"px",_.get("reposition")&&setTimeout(function(){E.bind("resize."+Z,J.position);},1),t.isFunction(i)&&i();},step:n});},J.resize=function(t){var e;$&&(t=t||{},t.width&&(_.w=a(t.width,"x")-N-j),t.innerWidth&&(_.w=a(t.innerWidth,"x")),L.css({width:_.w}),t.height&&(_.h=a(t.height,"y")-A-D),t.innerHeight&&(_.h=a(t.innerHeight,"y")),t.innerHeight||t.height||(e=L.scrollTop(),L.css({height:"auto"}),_.h=L.height()),L.css({height:_.h}),e&&L.scrollTop(e),J.position("none"===_.get("transition")?0:_.get("speed")));},J.prep=function(i){function o(){return _.w=_.w||L.width(),_.w=_.mw&&_.mw<_.w?_.mw:_.w,_.w}function a(){return _.h=_.h||L.height(),_.h=_.mh&&_.mh<_.h?_.mh:_.h,_.h}if($){var d,g="none"===_.get("transition")?0:_.get("speed");L.remove(),L=n(se,"LoadedContent").append(i),L.hide().appendTo(M.show()).css({width:o(),overflow:_.get("scrolling")?"auto":"hidden"}).css({height:a()}).prependTo(b),M.hide(),t(U).css({"float":"none"}),c(_.get("className")),d=function(){function i(){t.support.opacity===!1&&y[0].style.removeAttribute("filter");}var n,o,a=W.length;$&&(o=function(){clearTimeout(Q),S.hide(),u(ne),_.get("onComplete");},F.html(_.get("title")).show(),L.show(),a>1?("string"==typeof _.get("current")&&I.html(_.get("current").replace("{current}",z+1).replace("{total}",a)).show(),K[_.get("loop")||a-1>z?"show":"hide"]().html(_.get("next")),P[_.get("loop")||z?"show":"hide"]().html(_.get("previous")),ce(),_.get("preloading")&&t.each([h(-1),h(1)],function(){var i,n=W[this],o=new r(n,t.data(n,Y)),h=o.get("href");h&&s(o,h)&&(h=l(o,h),i=e.createElement("img"),i.src=h);})):O.hide(),_.get("iframe")?(n=e.createElement("iframe"),"frameBorder"in n&&(n.frameBorder=0),"allowTransparency"in n&&(n.allowTransparency="true"),_.get("scrolling")||(n.scrolling="no"),t(n).attr({src:_.get("href"),name:(new Date).getTime(),"class":Z+"Iframe",allowFullScreen:!0}).one("load",o).appendTo(L),ae.one(he,function(){n.src="//about:blank";}),_.get("fastIframe")&&t(n).trigger("load")):o(),"fade"===_.get("transition")?y.fadeTo(g,1,i):i());},"fade"===_.get("transition")?y.fadeTo(g,0,function(){J.position(0,d);}):J.position(g,d);}},J.next=function(){!q&&W[1]&&(_.get("loop")||W[z+1])&&(z=h(1),f(W[z]));},J.prev=function(){!q&&W[1]&&(_.get("loop")||z)&&(z=h(-1),f(W[z]));},J.close=function(){$&&!G&&(G=!0,$=!1,u(oe),_.get("onCleanup"),E.unbind("."+Z),v.fadeTo(_.get("fadeOut")||0,0),y.stop().fadeTo(_.get("fadeOut")||0,0,function(){y.hide(),v.hide(),u(he),L.remove(),setTimeout(function(){G=!1,u(re),_.get("onClosed");},1);}));},J.remove=function(){y&&(y.stop(),t[Y].close(),y.stop(!1,!0).remove(),v.remove(),G=!1,y=null,t("."+te).removeData(Y).removeClass(te),t(e).unbind("click."+Z).unbind("keydown."+Z));},J.element=function(){return t(_.el)},J.settings=X);})(jQuery,document,window);

	(function(e,t){function n(e){var t=Array.prototype.slice.call(arguments,1);return e.prop?e.prop.apply(e,t):e.attr.apply(e,t)}function s(e,t,n){var s,a;for(s in n)n.hasOwnProperty(s)&&(a=s.replace(/ |$/g,t.eventNamespace),e.bind(a,n[s]));}function a(e,t,n){s(e,n,{focus:function(){t.addClass(n.focusClass);},blur:function(){t.removeClass(n.focusClass),t.removeClass(n.activeClass);},mouseenter:function(){t.addClass(n.hoverClass);},mouseleave:function(){t.removeClass(n.hoverClass),t.removeClass(n.activeClass);},"mousedown touchbegin":function(){e.is(":disabled")||t.addClass(n.activeClass);},"mouseup touchend":function(){t.removeClass(n.activeClass);}});}function i(e,t){e.removeClass(t.hoverClass+" "+t.focusClass+" "+t.activeClass);}function r(e,t,n){n?e.addClass(t):e.removeClass(t);}function l(e,t,n){var s="checked",a=t.is(":"+s);t.prop?t.prop(s,a):a?t.attr(s,s):t.removeAttr(s),r(e,n.checkedClass,a);}function u(e,t,n){r(e,n.disabledClass,t.is(":disabled"));}function o(e,t,n){switch(n){case"after":return e.after(t),e.next();case"before":return e.before(t),e.prev();case"wrap":return e.wrap(t),e.parent()}return null}function c(t,s,a){var i,r,l;return a||(a={}),a=e.extend({bind:{},divClass:null,divWrap:"wrap",spanClass:null,spanHtml:null,spanWrap:"wrap"},a),i=e("<div />"),r=e("<span />"),s.autoHide&&t.is(":hidden")&&"none"===t.css("display")&&i.hide(),a.divClass&&i.addClass(a.divClass),s.wrapperClass&&i.addClass(s.wrapperClass),a.spanClass&&r.addClass(a.spanClass),l=n(t,"id"),s.useID&&l&&n(i,"id",s.idPrefix+"-"+l),a.spanHtml&&r.html(a.spanHtml),i=o(t,i,a.divWrap),r=o(t,r,a.spanWrap),u(i,t,s),{div:i,span:r}}function d(t,n){var s;return n.wrapperClass?(s=e("<span />").addClass(n.wrapperClass),s=o(t,s,"wrap")):null}function f(){var t,n,s,a;return a="rgb(120,2,153)",n=e('<div style="width:0;height:0;color:'+a+'">'),e("body").append(n),s=n.get(0),t=window.getComputedStyle?window.getComputedStyle(s,"").color:(s.currentStyle||s.style||{}).color,n.remove(),t.replace(/ /g,"")!==a}function p(t){return t?e("<span />").text(t).html():""}function m(){return navigator.cpuClass&&!navigator.product}function v(){return window.XMLHttpRequest!==void 0?!0:!1}function h(e){var t;return e[0].multiple?!0:(t=n(e,"size"),!t||1>=t?!1:!0)}function C(){return !1}function w(e,t){var n="none";s(e,t,{"selectstart dragstart mousedown":C}),e.css({MozUserSelect:n,msUserSelect:n,webkitUserSelect:n,userSelect:n});}function b(e,t,n){var s=e.val();""===s?s=n.fileDefaultHtml:(s=s.split(/[\/\\]+/),s=s[s.length-1]),t.text(s);}function y(e,t,n){var s,a;for(s=[],e.each(function(){var e;for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&(s.push({el:this,name:e,old:this.style[e]}),this.style[e]=t[e]);}),n();s.length;)a=s.pop(),a.el.style[a.name]=a.old;}function g(e,t){var n;n=e.parents(),n.push(e[0]),n=n.not(":visible"),y(n,{visibility:"hidden",display:"block",position:"absolute"},t);}function k(e,t){return function(){e.unwrap().unwrap().unbind(t.eventNamespace);}}var H=!0,x=!1,A=[{match:function(e){return e.is("a, button, :submit, :reset, input[type='button']")},apply:function(e,t){var r,l,o,d,f;return l=t.submitDefaultHtml,e.is(":reset")&&(l=t.resetDefaultHtml),d=e.is("a, button")?function(){return e.html()||l}:function(){return p(n(e,"value"))||l},o=c(e,t,{divClass:t.buttonClass,spanHtml:d()}),r=o.div,a(e,r,t),f=!1,s(r,t,{"click touchend":function(){var t,s,a,i;f||e.is(":disabled")||(f=!0,e[0].dispatchEvent?(t=document.createEvent("MouseEvents"),t.initEvent("click",!0,!0),s=e[0].dispatchEvent(t),e.is("a")&&s&&(a=n(e,"target"),i=n(e,"href"),a&&"_self"!==a?window.open(i,a):document.location.href=i)):e.click(),f=!1);}}),w(r,t),{remove:function(){return r.after(e),r.remove(),e.unbind(t.eventNamespace),e},update:function(){i(r,t),u(r,e,t),e.detach(),o.span.html(d()).append(e);}}}},{match:function(e){return e.is(":checkbox")},apply:function(e,t){var n,r,o;return n=c(e,t,{divClass:t.checkboxClass}),r=n.div,o=n.span,a(e,r,t),s(e,t,{"click touchend":function(){l(o,e,t);}}),l(o,e,t),{remove:k(e,t),update:function(){i(r,t),o.removeClass(t.checkedClass),l(o,e,t),u(r,e,t);}}}},{match:function(e){return e.is(":file")},apply:function(t,r){function l(){b(t,p,r);}var d,f,p,v;return d=c(t,r,{divClass:r.fileClass,spanClass:r.fileButtonClass,spanHtml:r.fileButtonHtml,spanWrap:"after"}),f=d.div,v=d.span,p=e("<span />").html(r.fileDefaultHtml),p.addClass(r.filenameClass),p=o(t,p,"after"),n(t,"size")||n(t,"size",f.width()/10),a(t,f,r),l(),m()?s(t,r,{click:function(){t.trigger("change"),setTimeout(l,0);}}):s(t,r,{change:l}),w(p,r),w(v,r),{remove:function(){return p.remove(),v.remove(),t.unwrap().unbind(r.eventNamespace)},update:function(){i(f,r),b(t,p,r),u(f,t,r);}}}},{match:function(e){if(e.is("input")){var t=(" "+n(e,"type")+" ").toLowerCase(),s=" color date datetime datetime-local email month number password search tel text time url week ";return s.indexOf(t)>=0}return !1},apply:function(e,t){var s,i;return s=n(e,"type"),e.addClass(t.inputClass),i=d(e,t),a(e,e,t),t.inputAddTypeAsClass&&e.addClass(s),{remove:function(){e.removeClass(t.inputClass),t.inputAddTypeAsClass&&e.removeClass(s),i&&e.unwrap();},update:C}}},{match:function(e){return e.is(":radio")},apply:function(t,r){var o,d,f;return o=c(t,r,{divClass:r.radioClass}),d=o.div,f=o.span,a(t,d,r),s(t,r,{"click touchend":function(){e.uniform.update(e(':radio[name="'+n(t,"name")+'"]'));}}),l(f,t,r),{remove:k(t,r),update:function(){i(d,r),l(f,t,r),u(d,t,r);}}}},{match:function(e){return e.is("select")&&!h(e)?!0:!1},apply:function(t,n){var r,l,o,d;return n.selectAutoWidth&&g(t,function(){d=t.width();}),r=c(t,n,{divClass:n.selectClass,spanHtml:(t.find(":selected:first")||t.find("option:first")).html(),spanWrap:"before"}),l=r.div,o=r.span,n.selectAutoWidth?g(t,function(){y(e([o[0],l[0]]),{display:"block"},function(){var e;e=o.outerWidth()-o.width(),l.width(d+e),o.width(d);});}):l.addClass("fixedWidth"),a(t,l,n),s(t,n,{change:function(){o.html(t.find(":selected").html()),l.removeClass(n.activeClass);},"click touchend":function(){var e=t.find(":selected").html();o.html()!==e&&t.trigger("change");},keyup:function(){o.html(t.find(":selected").html());}}),w(o,n),{remove:function(){return o.remove(),t.unwrap().unbind(n.eventNamespace),t},update:function(){n.selectAutoWidth?(e.uniform.restore(t),t.uniform(n)):(i(l,n),o.html(t.find(":selected").html()),u(l,t,n));}}}},{match:function(e){return e.is("select")&&h(e)?!0:!1},apply:function(e,t){var n;return e.addClass(t.selectMultiClass),n=d(e,t),a(e,e,t),{remove:function(){e.removeClass(t.selectMultiClass),n&&e.unwrap();},update:C}}},{match:function(e){return e.is("textarea")},apply:function(e,t){var n;return e.addClass(t.textareaClass),n=d(e,t),a(e,e,t),{remove:function(){e.removeClass(t.textareaClass),n&&e.unwrap();},update:C}}}];m()&&!v()&&(H=!1),e.uniform={defaults:{activeClass:"active",autoHide:!0,buttonClass:"button",checkboxClass:"checker",checkedClass:"checked",disabledClass:"disabled",eventNamespace:".uniform",fileButtonClass:"action",fileButtonHtml:"Choose File",fileClass:"uploader",fileDefaultHtml:"No file selected",filenameClass:"filename",focusClass:"focus",hoverClass:"hover",idPrefix:"uniform",inputAddTypeAsClass:!0,inputClass:"uniform-input",radioClass:"radio",resetDefaultHtml:"Reset",resetSelector:!1,selectAutoWidth:!0,selectClass:"selector",selectMultiClass:"uniform-multiselect",submitDefaultHtml:"Submit",textareaClass:"uniform",useID:!0,wrapperClass:null},elements:[]},e.fn.uniform=function(t){var n=this;return t=e.extend({},e.uniform.defaults,t),x||(x=!0,f()&&(H=!1)),H?(t.resetSelector&&e(t.resetSelector).mouseup(function(){window.setTimeout(function(){e.uniform.update(n);},10);}),this.each(function(){var n,s,a,i=e(this);if(i.data("uniformed"))return e.uniform.update(i),void 0;for(n=0;A.length>n;n+=1)if(s=A[n],s.match(i,t))return a=s.apply(i,t),i.data("uniformed",a),e.uniform.elements.push(i.get(0)),void 0})):this},e.uniform.restore=e.fn.uniform.restore=function(n){n===t&&(n=e.uniform.elements),e(n).each(function(){var t,n,s=e(this);n=s.data("uniformed"),n&&(n.remove(),t=e.inArray(this,e.uniform.elements),t>=0&&e.uniform.elements.splice(t,1),s.removeData("uniformed"));});},e.uniform.update=e.fn.uniform.update=function(n){n===t&&(n=e.uniform.elements),e(n).each(function(){var t,n=e(this);t=n.data("uniformed"),t&&t.update(n,t.options);});};})(jQuery);

	if ($("#propertyDetails .gallery").length > 0) {
		$('#propertyDetails .gallery #large').flexslider({
			animation: "slide",
			controlNav: false,
			animationLoop: true,
			slideshow: false,
			directionNav: true,
			smoothHeight: false,
			sync: "#thumbnails",
			start: function(slider) {
				$('#propertyDetails .gallery #thumbnails').css("opacity", "1");
			}  						
		});
		$('#propertyDetails .gallery #thumbnails').flexslider({
			directionNav: false,
			animation: "slide",
			controlNav: false,
			animationLoop: true,
			slideshow: false,
			itemWidth: 192,
			itemMargin: 10,
			asNavFor: '#large'
		});
	}

	$(document).ready(function() {
			
		//Videos lightbox
		if ($(".lightbox").length > 0) {
			$(".lightbox").colorbox({
				width: "700px",
				height: "500px",
				maxWidth: "96%",
				scrolling: false
			});
		}

		if ($("#carousel").length > 0) {
			$('#carousel').flexslider({
				animation: "fade",
				controlNav: true,
				slideshowSpeed: 15000,
				animationLoop: true,
				slideshow: true,
				slideshowSpeed: 8000,
				directionNav: false,
				smoothHeight: false
			});
		}
		if ($("#featuredProperty").length > 0) {
			$('#featuredProperty').flexslider({
				animation: "fade",
				slideshowSpeed: 15000,
				controlNav: false,
				animationLoop: true,
				slideshow: true,
				slideshowSpeed: 8000,
				directionNav: false,
				smoothHeight: false
			});
		}
		if ($("#testimonials").length > 0) {
			$('#testimonials').flexslider({
				animation: "fade",
				slideshowSpeed: 15000,
				controlNav: false,
				animationLoop: true,
				slideshow: true,
				slideshowSpeed: 8000,
				directionNav: false,
				smoothHeight: true
			});
		}
		$('#header .burger').click(function() {
			$(this).toggleClass('animate');
			$('#header #nav').slideToggle(500);
		});
		
		// $('#header .valuation').click(function() {
		// 	$('#header #valuation').slideToggle(500);
		// });
		
		// $('#header #valuation .close').click(function() {
		// 	$('#header #valuation').slideUp(500);
		// });

		$("select").uniform();
		
		$('#footer .arrow').hover(function() {
			$(this).hide();
			$(this).attr("src", $(this).attr("src").replace("-white", "-grey"));
			$(this).fadeIn(500);
		},
		function() {
			$(this).hide();
			$(this).attr("src", $(this).attr("src").replace("-grey", "-white"));
			$(this).fadeIn(500);
		});

		//Onclick scroll to top of page
		$('#footer .arrow').click(function() {
			$('body, html').animate({scrollTop: 0}, 800);
			return false;
		});

		//Map
		if ($("#propertyDetails #map").length > 0) {
		
			var latlng = new google.maps.LatLng(document.getElementById('latitude').innerHTML, document.getElementById('longitude').innerHTML);
			var myOptions = {
				zoom: 15,
				center: latlng,
				scrollwheel: false,
				draggable: true
		    };

		    var map = new google.maps.Map(document.getElementById('map'),myOptions);
		    var infowindow = new google.maps.InfoWindow();
		    var marker, i;


	        var icon = {
	            anchor: new google.maps.Point(15, 42),
	            scaledSize: new google.maps.Size(30, 42),
	            size: new google.maps.Size(30, 42),
	            url: '/wp-content/themes/clarkeandsimpson/images/icons/map-marker.svg'
	        };

			marker = new google.maps.Marker({
		        position: latlng,
				animation: google.maps.Animation.DROP,
				map: map,
	            icon: icon,
				title: 'Property Location'
			});
		
		    //Change map center on window size change
		    var center;
		
			function calculateCenter() {
				center = map.getCenter();
			}
			google.maps.event.addDomListener(map, 'idle', function() {
				calculateCenter();
			});
			google.maps.event.addDomListener(window, 'resize', function() {
				map.setCenter(center);
			});

		}

		//Contact Map
		if ($("#contentPage #map").length > 0) {
			var locations = [
				['Clarke & Simpson', 52.222066, 1.341188, 'officeMain'],
				['Clarke & Simpson Auction Centre', 52.152295, 1.396562, 'officeAuctions']
		    ];
		
			var myOptions = {
				zoom: 10,
				center: new google.maps.LatLng(52.194140, 1.101630),
				scrollwheel: false,
				panControl: true
				//draggable: false
		    };
		
		    var map = new google.maps.Map(document.getElementById('map'),myOptions);
		
		    //Change map center on window size change
		    var center;
		
			function calculateCenter() {
				center = map.getCenter();
			}
			google.maps.event.addDomListener(map, 'idle', function() {
				calculateCenter();
			});
			google.maps.event.addDomListener(window, 'resize', function() {
				map.setCenter(center);
			});
		
			//Set map marker
			var image = '/wp-content/themes/clarkeandsimpson/images/icons/map-marker.png';

		    var infowindow = new google.maps.InfoWindow();
		    var marker, i;
		
		    for (i = 0; i < locations.length; i++) {  
				marker = new google.maps.Marker({
					position: new google.maps.LatLng(locations[i][1], locations[i][2]),
					icon: image,
					animation: google.maps.Animation.DROP,
					map: map
				});
				google.maps.event.addListener(marker, 'click', (function(marker, i) {
					return function() {
						infowindow.setContent('<div class="officeTooltip"><p>' + $('#' + locations[i][3]).html() + '</p></div>');
						infowindow.open(map, marker);
		        	}
				})(marker, i));
		    }
		}
	});

	//Form validation
	$('#contactForm').submit(function() {

		//Declare all fields
		var $full_name = $("#contactForm input[name=full_name]");
		var $email_address = $("#contactForm input[name=email_address]");
		
		//Email address validation
	    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	    var emailaddressVal = $email_address.val();

		//Validate required fields
		if($full_name.val() == "") {
			$full_name.addClass('error');
			$full_name.val('');
			$full_name.attr('placeholder', 'Please enter your full name');
			return false;
		} else {
			$full_name.removeClass('error');
		}
	    
	    //Validate email address
		if($email_address.val() == "") {
			$email_address.addClass('error');
			$email_address.val('');
			$email_address.attr('placeholder', 'Please enter your email address');
			return false;
		} else {
			$email_address.removeClass('error');
		}
	    if(!emailReg.test(emailaddressVal)) {
			$email_address.addClass('error');
			$email_address.val('');
			$email_address.attr('placeholder', 'Please enter a valid email address');
			return false;
	    } else {
			$email_address.removeClass('error');
		}

	});

	//SVG support
	svgeezy.init(false, 'png');

	function formatNumber(nStr) {
		nStr += '';
		let x = nStr.split('.');
	    let x1 = x[0];
	    let x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2');
		}
		return x1 + x2;
	}

	//Property search department buttons
	if ($("#propertySearch .buttons").length > 0) {
		$('#propertySearch .buttons span').click(function() {
			$('#propertySearch .buttons span').removeClass('active');
			$(this).addClass('active');
			switch (true) {
			    case $(this).hasClass('sales') : $('#departmentField').val('Sales'); updateSearchPrices('Sales'); break;
			    case $(this).hasClass('lettings') : $('#departmentField').val('Lettings'); updateSearchPrices('Lettings'); break;
			    case $(this).hasClass('commercial') : $('#departmentField').val('Commercial'); updateSearchPrices('Sales'); break;
			    case $(this).hasClass('land') : $('#departmentField').val('Agricultural'); updateSearchPrices('Sales'); break;
		    }
		});
	}
		
	//Function to update search prices on change of department
	function updateSearchPrices(department) {
		
		if(department == 'Lettings') {
			
			//Update min price select options if max price select exists
			if ($(".minprice").length > 0) {
				//$(".minprice").empty();
				
				var output = [];
				var i = 0;
				
				//Add blank option
				output.push('<option value="">' + minBlankOption + '</option>');
				//Add option for each price in array
				$.each(minRentArray, function(key, arrayItemValue) {
					i ++;
					//If rent is not the last
					if(i != minRentArray.length) {
						output.push('<option value="' + arrayItemValue + '">&pound;' + formatNumber(arrayItemValue) + ' pcm</option>');
					}
				});
				
				$('.minprice').html(output.join(''));
			}
			
			//Update max price select options if max price select exists
			if ($(".maxprice").length > 0) {
				$(".maxprice").empty();
				
				var output = [];
				var i = 0;
				
				//Add blank option
				output.push('<option value="">' + maxBlankOption + '</option>');
				//Add option for each price in array
				$.each(maxRentArray, function(key, arrayItemValue) {
					i ++;
					//If rent is not the last 
					if(i != maxRentArray.length) {
						output.push('<option value="' + arrayItemValue + '">&pound;' + formatNumber(arrayItemValue) + ' pcm</option>');
					}
				});
				
				$('.maxprice').html(output.join(''));
			}
			
		} else {

			//Update min price select options if max price select exists
			if ($(".minprice").length > 0) {
				$(".minprice").empty();
				
				var output = [];
				
				//Add blank option
				output.push('<option value="">' + minBlankOption + '</option>');
				//Add option for each price in array
				$.each(minPriceArray, function(key, arrayItemValue) {
					if(i != minPriceArray.length) {
						output.push('<option value="' + arrayItemValue + '">&pound;' + formatNumber(arrayItemValue) + '</option>');
					}
				});
				
				$('.minprice').html(output.join(''));
			}
			
			//Update max price select options if max price select exists
			if ($(".maxprice").length > 0) {
				$(".maxprice").empty();
				
				var output = [];
				
				//Add blank option
				output.push('<option value="">' + maxBlankOption + '</option>');
				//Add option for each price in array
				$.each(maxPriceArray, function(key, arrayItemValue) {
					if(i != maxPriceArray.length) {
						output.push('<option value="' + arrayItemValue + '">&pound;' + formatNumber(arrayItemValue) + '</option>');
					}
				});
				
				$('.maxprice').html(output.join(''));
			}
		}
	}

	//Stick header
	$(window).scroll(function(e) {
		// Get position of the element where the scroller starts.
		var $stickyElement = $("#header");
		 
		if ($(this).scrollTop() >=10) {
			$($stickyElement).addClass("sticky");
			// Change the height of the scroller anchor to so there is no change in the overall height of the page.
		} else  {
	        $($stickyElement).removeClass("sticky");
		}
	});

	//Fix scale for iOS devices on orientation change 
	if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
		var viewportmeta = document.querySelector('meta[name="viewport"]');
		if (viewportmeta) {
			viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0, user-scalable=no';
			document.body.addEventListener('gesturestart', function () {
				viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6, user-scalable=no';
			}, false);
		}
	}

	//Apend class to body if IE 7 - 11
	var iev = 0;
	var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
	var trident = !!navigator.userAgent.match(/Trident\/7.0/);
	var rv=navigator.userAgent.indexOf("rv:11.0");

	if (ieold) iev = new Number(RegExp.$1);
	if (navigator.appVersion.indexOf("MSIE 10") != -1) iev = 10;
	if (trident && rv != -1) iev = 11;

	if(iev == 7 || iev == 8 || iev == 9 || iev == 10 || iev == 11) {
		document.documentElement.className += 'ie' + iev;
	}

	//Show/hide fields on select of department in propetyy search
	$('#propertySearch .buttons span').each(function()
	{
		$(this).click(function()
	    {
	        var department = $(this).data('department');

	        if(department === 'Sales' || department === 'Lettings')
			{
	            $('.residential-property-search-fields').show();
	            $('.residential-property-search-fields input, #searchFields select').attr('disabled', false);

	            if(department === 'Sales')
				{
	                $('.sales-property-fields').show();
	                $('.sales-property-fields input').attr('disabled', false);
	                $('.lettings-property-fields').hide();
	                $('.lettings-property-fields input').attr('disabled', 'disabled');
				}
				else
				{
	                $('.sales-property-fields').hide();
	                $('.sales-property-fields input').attr('disabled', 'disabled');
	                $('.lettings-property-fields').show();
	                $('.lettings-property-fields input').attr('disabled', false);
				}
			}
			else
			{
	            $('.residential-property-search-fields').hide();
	            $('.residential-property-search-fields input, #searchFields select').attr('disabled', 'disabled');
			}
	    });
	});

	const propertyMapSearch =
	{
	    propertyMapSearchMap: document.getElementById('property-search-map'),
	    propertySearchForm: document.getElementById('searchForm'),
	    icon: null,
	    infowindow: new google.maps.InfoWindow(),
	    bounds: null,
	    map: null,
	    markers: [],
	    init()
	    {
	        //Set up the map
	        if(this.propertyMapSearchMap)
	        {
	            this.setup();
	        }


	        //Update the map markers on change/tick of a field in the property search form
	        if(this.propertySearchForm)
	        {
	            for(let formSelect of this.propertySearchForm.querySelectorAll('select'))
	            {
	                formSelect.addEventListener("change", () =>
	                {
	                    this.propertySearchForm.submit();
	                });
	            }

	            for(let formCheckbox of this.propertySearchForm.querySelectorAll('input[type=checkbox]'))
	            {
	                formCheckbox.addEventListener("click", event =>
	                {
	                    //Fix for IE as event.preventDefault is not supported
	                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

	                    this.propertySearchForm.submit();
	                });
	            }
	        }
	    },
	    setup: function()
	    {
	        //Set lat and long of map
	        let lat = this.propertyMapSearchMap.getAttribute('data-lat'),
	            lng = this.propertyMapSearchMap.getAttribute('data-lng'),
	            savedPropertiesOnly = this.propertyMapSearchMap.getAttribute('data-saved-properties-only');


	        //Create infowindow object
	        propertyMapSearch.infowindow =  new google.maps.InfoWindow({});


	        //Initialise the map
	        propertyMapSearch.map = new google.maps.Map(propertyMapSearch.propertyMapSearchMap, {
	            zoom: 14,
	            styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":5},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
	            center: new google.maps.LatLng(lat, lng),
	            mapTypeControl: false,
	            fullscreenControlOptions: {
	                position: google.maps.ControlPosition.BOTTOM_LEFT
	            }
	        });


	        //Set the map to zoom out so all markers show by default
	        let bounds = new google.maps.LatLngBounds();


	        let properties = this.getPropertyData(savedPropertiesOnly);

	        //Add markers to the map and return each marker for marker clusterer below
	        let markers = this.getPropertyData().map(function(property)
	        {
	            let markerLatLong = new google.maps.LatLng(property.latitude, property.longitude);

	            propertyMapSearch.addMarker(property, propertyMapSearch.map);

	            //Add marker to bounds to fit the map to all markers
	            bounds.extend(markerLatLong);
	        });

	        //If one marker is returned
	        if(properties.length === 1)
	        {
	            //Zoom the map out
	            propertyMapSearch.map.setZoom(12);


	            //Center the map to the marker
	            if(markers[0])
	            {
	                propertyMapSearch.map.setCenter(markers[0].getPosition());
	            }
	        }
	        else
	        {
	            //Fit the map bounds to include all of the markers
	            propertyMapSearch.map.fitBounds(bounds);
	        }

	        //Check if any properties are returned via the http request to property-map-properties.php
	        // if(properties.length)
	        // {
	        //     //Add markers to the map and return each marker for marker clusterer below
	        //     let markers = properties.map(function(property)
	        //     {
	        //         let markerLatLong = new google.maps.LatLng(property.latitude, property.longitude);
	        //
	        //         //Add marker to bounds to fit the map to all markers
	        //         bounds.extend(markerLatLong);
	        //
	        //         return propertyMapSearch.addMarker(property);
	        //     });
	        //
	        //
	        //     //If one marker is returned
	        //     if(properties.length === 1)
	        //     {
	        //         //Zoom the map out
	        //         propertyMapSearch.map.setZoom(12);
	        //
	        //
	        //         //Center the map to the marker
	        //         if(markers[0])
	        //         {
	        //             propertyMapSearch.map.setCenter(markers[0].getPosition());
	        //         }
	        //     }
	        //     else
	        //     {
	        //         //Fit the map bounds to include all of the markers
	        //         propertyMapSearch.map.fitBounds(bounds);
	        //     }
	        //
	        //
	        //     //add marker clusterer to the map
	        //     this.addMarkerClusterer(markers);
	        // }
	    },
	    //Grab property data from json and build up an array of properties
	    getPropertyData: function(savedPropertiesOnly)
	    {
	        let properties = '';

	        //Create a set of key/value pairs for fields in property search form. If no form exists, check if this is the saved properties page. If so pass a param for that
	        let formData = this.propertySearchForm ? this.serializeForm(this.propertySearchForm) : (savedPropertiesOnly ? 'saved-properties=true' : '');

	        $.ajax({
	            url: "/wp-content/themes/clarkeandsimpson/includes/property-map-properties.php?" + formData,
	            async: false,
	            dataType: 'json',
	            success: function(json)
	            {
	                if(json.properties)
	                {
	                    properties = json.properties;
	                }
	                else
	                {
	                    properties = false;
	                }
	            }
	        });

	        return properties;
	    },
	    serializeForm: function(form)
	    {
	        let formData = new FormData(form),
	            formDataParams = '',
	            i = 0;

	        for(let key of formData.keys())
	        {
	            formDataParams += (i !== 0 ? '&' : '') + (key + '=' + formData.get(key));

	            i ++;
	        }

	        return formDataParams;
	    },
	    //Add the marker, set the onclick event and return the marker at the end so it is returned for the marker clusterer plugin
	    addMarker: function(property, map)
	    {
	        propertyMapSearch.icon = {
	            scaledSize: new google.maps.Size(32, 32),
	            size: new google.maps.Size(32, 32),
	            url: '/wp-content/themes/clarkeandsimpson/images/icons/map-marker.svg'
	        };

	        let marker = new google.maps.Marker({
	            position: new google.maps.LatLng(property.latitude, property.longitude),
	            icon: propertyMapSearch.icon,
	            title: property.title.rendered,
	            animation: google.maps.Animation.DROP,
	            map: map
	        });


	        //On click of a marker, show the info window
	        marker.addListener("click", () =>
	        {
	            let activeMarkerPropertyListing = document.getElementById('property-' + property.post_id),
	                propertyListings = document.querySelectorAll('#property-search-list-container .listing'),
	                propertyListContainer = document.getElementById('property-search-list-container');


	            //Remove active state from any property listings
	            for(let propertyListing of propertyListings)
	            {
	                propertyListing.classList.remove('listing--active');
	            }


	            //Add active state to active property listing
	            if(activeMarkerPropertyListing)
	            {
	                activeMarkerPropertyListing.classList.add('listing--active');


	                //Scroll to the property
	                if(window.matchMedia('(min-width: 1200px)').matches)
	                {
	                    //scroll the property lists div to the active property listing - the active property listing element height
	                    propertyListContainer.scrollTop = activeMarkerPropertyListing.offsetTop - activeMarkerPropertyListing.offsetHeight - 375;
	                }
	                else
	                {
	                    activeMarkerPropertyListing.scrollIntoView({behavior: "smooth"});
	                }
	            }
	        });

	        return marker;
	    },
	    addMarkerClusterer: function(markers)
	    {
	        // Add a marker clusterer to manage the markers
	        let markerCluster = new MarkerClusterer(
	            propertyMapSearch.map, markers,
	            {
	                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
	            }
	        );
	    }
	};

	const stampDutyCalc = {
	    stampDutyCalcForms: document.querySelectorAll('#stamp-duty-calculator-form'),
	    init()
	    {
	        this.setup();
	    },
	    setup()
	    {
	        for(let stampDutyCalcForm of this.stampDutyCalcForms)
	        {
	            this.calculate(stampDutyCalcForm);


	            let formFields = stampDutyCalcForm.querySelectorAll('select, input, textarea');

	            for(let formField of formFields)
	            {
	                if(formField.getAttribute('type') === 'checkbox')
	                {
	                    formField.addEventListener("click", event =>
	                    {
	                        this.calculate(stampDutyCalcForm);
	                    });
	                }
	                else
	                {
	                    formField.addEventListener("keyup", event =>
	                    {
	                        this.calculate(stampDutyCalcForm);
	                    });

	                    formField.addEventListener("change", event =>
	                    {
	                        this.calculate(stampDutyCalcForm);
	                    });
	                }
	            }
	        }
	    },
	    formatPrice(number_to_format) {
			number_to_format += '';
			// x = number_to_format.split('.');
			// x1 = x[0];
			// x2 = x.length > 1 ? '.' + x[1] : '';
			// var rgx = /(\d+)(\d{3})/;
			// while (rgx.test(x1)) {
			// 	x1 = x1.replace(rgx, '$1' + ',' + '$2');
			// }
			// return x1 + x2;
	        return number_to_format;
		},
	    calculate(stampDutyCalcForm)
	    {

	        let is_secondary = stampDutyCalcForm.querySelector('#sdc-buy-to-let').checked,
	            is_first_time_buyer = stampDutyCalcForm.querySelector('#sdc-first-time-buyer').checked,
	            purchaseprice = stampDutyCalcForm.querySelector('#sdc-purchaseprice').value.replace(new RegExp(/[^?0-9.]/g), "");

	        var language_upto = 'Up to ';
	            if(document.getElementById('cw-language-string-upto_label')) {
	                language_upto = document.getElementById('cw-language-string-upto_label').innerHTML;
	            }

	        // Second home or BTL
	        if(is_secondary) {
	            var rates_1oct21 = [];
	                rates_1oct21['a'] = [0, 125000, 5, language_upto+' &pound;125,000'];
	                rates_1oct21['b'] = [125001, 250000, 7, '&pound;125,001 - &pound;250,000'];
	                rates_1oct21['c'] = [250001, 925000, 10, '&pound;250,001 - &pound;925,000'];
	                rates_1oct21['d'] = [925001, 1500000, 15, '&pound;925,001 - &pound;1,500,000'];
	                rates_1oct21['e'] = [1500001, 999999999, 17, 'Above &pound;1,500,000'];
	        // First time buyer
	        } else if(is_first_time_buyer) {
	            var rates_1oct21 = [];
	                rates_1oct21['a'] = [0, 300000, 0, language_upto+' &pound;300,000'];
	                rates_1oct21['b'] = [300001, 925000, 5, '&pound;300,001 - &pound;925,000'];
	                rates_1oct21['c'] = [925001, 1500000, 10, '&pound;925,001 - &pound;1,500,000'];
	                rates_1oct21['d'] = [1500000, 999999999, 12, 'Above &pound;1,500,000'];
	        } else {
	            var rates_1oct21 = [];
	                rates_1oct21['a'] = [0, 125000, 0, language_upto+' &pound;125,000'];
	                rates_1oct21['b'] = [125001, 250000, 2, '&pound;125,001 - &pound;250,000'];
	                rates_1oct21['c'] = [250001, 925000, 5, '&pound;250,001 - &pound;925,000'];
	                rates_1oct21['d'] = [925001, 1500000, 10, '&pound;925,001 - &pound;1,500,000'];
	                rates_1oct21['e'] = [1500000, 999999999, 12, 'Above &pound;1,500,000'];
	        }

	        if(false) {
	            var rates;
	        } else if(false) {
	            var rates;
	        } else {
	            var rates = rates_1oct21;
	        }
	        // console.log(rates);

	        if(rates['a']) {
	            var this_rate = rates['a'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_a_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_a_amount = purchaseprice - this_rate_from;
	                if(rate_a_amount < 0) { rate_a_amount = 0; }
	            }
	        }

	        if(rates['b']) {
	            var this_rate = rates['b'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_b_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_b_amount = purchaseprice - this_rate_from;
	                if(rate_b_amount < 0) { rate_b_amount = 0; }
	            }
	        }

	        if(rates['c']) {
	            var this_rate = rates['c'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_c_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_c_amount = purchaseprice - this_rate_from;
	                if(rate_c_amount < 0) { rate_c_amount = 0; }
	            }
	        }

	        if(rates['d']) {
	            var this_rate = rates['d'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_d_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_d_amount = purchaseprice - this_rate_from;
	                if(rate_d_amount < 0) { rate_d_amount = 0; }
	            }
	        }

	        if(rates['e']) {
	            var this_rate = rates['e'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_e_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_e_amount = purchaseprice - this_rate_from;
	                if(rate_e_amount < 0) { rate_e_amount = 0; }
	            }
	        }

	        if(rates['f']) {
	            var this_rate = rates['f'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_f_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_f_amount = purchaseprice - this_rate_from;
	                if(rate_f_amount < 0) { rate_f_amount = 0; }
	            }
	        }

	        if(rates['g']) {
	            var this_rate = rates['g'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_g_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_g_amount = purchaseprice - this_rate_from;
	                if(rate_g_amount < 0) { rate_g_amount = 0; }
	            }
	        }

	        if(rates['h']) {
	            var this_rate = rates['h'];
	            var this_rate_from = this_rate[0];
	            var this_rate_to = this_rate[1];
	            var this_rate_percentage = this_rate[2];
	            var this_rate_table_label = this_rate[3];
	            if(purchaseprice > this_rate_to) {
	                var rate_h_amount = this_rate_to - this_rate_from;
	            } else {
	                var rate_h_amount = purchaseprice - this_rate_from;
	                if(rate_h_amount < 0) { rate_h_amount = 0; }
	            }
	        }

	        if(rates['a']) { var rate_a_total = parseInt((rate_a_amount/100)*rates['a'][2]); } else { var rate_a_total = 0; }
	        if(rates['b']) { var rate_b_total = parseInt((rate_b_amount/100)*rates['b'][2]); } else { var rate_b_total = 0; }
	        if(rates['c']) { var rate_c_total = parseInt((rate_c_amount/100)*rates['c'][2]); } else { var rate_c_total = 0; }
	        if(rates['d']) { var rate_d_total = parseInt((rate_d_amount/100)*rates['d'][2]); } else { var rate_d_total = 0; }
	        if(rates['e']) { var rate_e_total = parseInt((rate_e_amount/100)*rates['e'][2]); } else { var rate_e_total = 0; }
	        if(rates['f']) { var rate_f_total = parseInt((rate_f_amount/100)*rates['f'][2]); } else { var rate_f_total = 0; }
	        if(rates['g']) { var rate_g_total = parseInt((rate_g_amount/100)*rates['g'][2]); } else { var rate_g_total = 0; }
	        if(rates['h']) { var rate_h_total = parseInt((rate_h_amount/100)*rates['h'][2]); } else { var rate_h_total = 0; }

	        if(purchaseprice < 40000) {
	            rate_a_total = 0;
	        }

	        var grand_total = rate_a_total+rate_b_total+rate_c_total+rate_d_total+rate_e_total+rate_f_total+rate_g_total+rate_h_total;
	        var rate_percentage_total = ((grand_total/purchaseprice)*100).toFixed(1);

	        var table_label_band = 'Band';
	        if(document.getElementById('cw-language-string-band_label')) {
	            var table_label_band = document.getElementById('cw-language-string-band_label').innerHTML;
	        }
	        var table_label_rate = 'Rate';
	        if(document.getElementById('cw-language-string-rate_label')) {
	            var table_label_rate = document.getElementById('cw-language-string-rate_label').innerHTML;
	        }
	        var table_label_amount = 'Amount';
	        if(document.getElementById('cw-language-string-amount_label')) {
	            var table_label_amount = document.getElementById('cw-language-string-amount_label').innerHTML;
	        }
	        var table_label_total = 'Total';
	        if(document.getElementById('cw-language-string-total_label')) {
	            var table_label_total = document.getElementById('cw-language-string-total_label').innerHTML;
	        }
	        var table_label_stamp_duty_due = '';
	        if(document.getElementById('cw-language-string-stamp_duty_due_label')) {
	            var table_label_stamp_duty_due = document.getElementById('cw-language-string-stamp_duty_due_label').innerHTML;
	        }

	        if(grand_total > 0) {
	            var table_html = '<table cellpadding=0 cellspacing=0><thead>\
                <tr>\
                    <th>'+table_label_rate+'</th>\
                    <th>'+table_label_band+'</th>\
                    <th>'+table_label_amount+'</th>\
                </tr></thead><tbody>\
            ';
	            // if(rate_a_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['a'][3]+'</td>\
                    <td>'+rates['a'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_a_total)+'</td>\
                </tr>';
	            // }
	            if(rate_b_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['b'][3]+'</td>\
                    <td>'+rates['b'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_b_total)+'</td>\
                </tr>';
	            }
	            if(rate_c_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['c'][3]+'</td>\
                    <td>'+rates['c'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_c_total)+'</td>\
                </tr>';
	            }
	            if(rate_d_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['d'][3]+'</td>\
                    <td>'+rates['d'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_d_total)+'</td>\
                </tr>';
	            }
	            if(rate_e_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['e'][3]+'</td>\
                    <td>'+rates['e'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_e_total)+'</td>\
                </tr>';
	            }
	            if(rate_f_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['f'][3]+'</td>\
                    <td>'+rates['f'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_f_total)+'</td>\
                </tr>';
	            }
	            if(rate_g_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['g'][3]+'</td>\
                    <td>'+rates['g'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_g_total)+'</td>\
                </tr>';
	            }
	            if(rate_h_total > 0) { 
	                table_html += '<tr>\
                    <td>'+rates['h'][3]+'</td>\
                    <td>'+rates['h'][2]+'%</td>\
                    <td>&pound;'+this.formatPrice(rate_h_total)+'</td>\
                </tr>';
	            }
	            

	            table_html += '</tbody><tfoot><tr>\
                <td>Total</td>\
                <td>'+rate_percentage_total+'%</td>\
                <td>&pound;'+this.formatPrice(grand_total)+'</td>\
            </tr></tfoot>';

	            table_html += '</table>';
	        }

	        stampDutyCalcForm.querySelector('#sdc-results-total').innerHTML = table_label_stamp_duty_due+' <span>&pound;' + grand_total.toLocaleString('en-GB', {maximumFractionDigits: 2}) + '</span>';
	        
	        if(table_html)
	        {
	            stampDutyCalcForm.querySelector('#sdc-results-table').innerHTML = table_html;
	        }

	        return false;
	    }
	};

	propertyMapSearch.init();
	stampDutyCalc.init();

}());
